<template>
  <div>
    <div class="title">
     <el-select
        v-model="merchart_id"
         v-if="isPosSwitch==true"
        class="wid_2"
        @change="merChange()"
        placeholder="请选择"
      >
        <el-option
          v-for="item in merchart"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-select
        v-model="area_id"
        class="wid_l"
        @change="seChange()"
        placeholder="请选择"
        :value="123123"

      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>

    </div>
    <div class="top-div">
      <el-card class="top-card">
        <div class="top-info1">
          <div class="svg-position">
            <svg-icon icon-class="new_orders" class="svg-class"/>
            <div class="content-info">新订单</div>
          </div>
          <div class="top-item-info1">
            <span>{{ top.new_order.new_num }}</span>
            <div class="change-num">
              <span class="card-panel-change-text">同比昨日</span>
              <svg-icon v-show="top.new_order.diff == '1' " icon-class="down" class="down"/>
              <svg-icon v-show="top.new_order.diff == '2' " icon-class="level" class="down"/>
              <svg-icon v-show="top.new_order.diff == '3' " icon-class="upup" class="down"/>
              {{ top.new_order.difference }}
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="top-card">
        <div class="top-info1">
          <div class="svg-position">
            <svg-icon icon-class="many_people" class="svg-class"/>
            <div class="content-info">总用户</div>
          </div>
          <div class="top-item-info1">
            <span>{{ top.total_user.total_num }}</span>
            <div class="change-num">
              <span class="card-panel-change-text">同比昨日</span>
              <svg-icon v-show="top.total_user.diff == '1' " icon-class="down" class="down"/>
              <svg-icon v-show="top.total_user.diff == '2' " icon-class="level" class="down"/>
              <svg-icon v-show="top.total_user.diff == '3' " icon-class="upup" class="down"/>
              {{ top.total_user.difference }}
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="top-card">
        <div class="top-info1">
          <div class="svg-position">
            <svg-icon icon-class="total_orders" class="svg-class"/>
            <div class="content-info">本月累计押金</div>
          </div>
          <div class="top-item-info1">
            <span>{{ top.cumulative_profit.cumulative_profit_num }}</span>
            <!-- <div class="change-num">
              <span class="card-panel-change-text">同比昨日</span>
              <svg-icon v-show="top.total_order.diff == '1' " icon-class="down" class="down"/>
              <svg-icon v-show="top.total_order.diff == '2' " icon-class="level" class="down"/>
              <svg-icon v-show="top.total_order.diff == '3' " icon-class="upup" class="down"/>
              {{ top.total_order.difference }}
            </div> -->
          </div>
        </div>
      </el-card>
      <el-card class="top-card">
        <div class="top-info1">
          <div class="svg-position">
            <svg-icon icon-class="total_profit" class="svg-class"/>
            <div class="content-info">本月总收益</div>
          </div>
          <div class="top-item-info1">
            <span>{{ top.total_profit.total_num }}</span>
            <!-- <div class="change-num">
              <span class="card-panel-change-text">同比昨日</span>
              <svg-icon v-show="top.total_profit.diff == '1' " icon-class="down" class="down"/>
              <svg-icon v-show="top.total_profit.diff == '2' " icon-class="level" class="down"/>
              <svg-icon v-show="top.total_profit.diff == '3' " icon-class="upup" class="down"/>
              {{ top.total_profit.difference }}
            </div> -->
          </div>
        </div>
      </el-card>
    </div>
    <div class="mid-div">
      <div style="width:48%;">
        <el-card>
          <span class="todo-title">待办事项</span>
          <div class="todo-event">
            <el-card>
              <div>
                <p class="red-class">{{ todo_event.low_battery_num }}</p>
                <span>低电量车辆</span>
              </div>
            </el-card>
            <el-card>
              <div>
                <p>{{ todo_event.current_cycling_num }}</p>
                <span>当前骑行车辆</span>
              </div>
            </el-card>
            <el-card>
              <div>
                <p>{{ todo_event.long_time_no_return_ridding }}</p>
                <span>24h未还车辆</span>
              </div>
            </el-card>
            <el-card>
              <div>
                <p class="red-class">{{ todo_event.trouble_num }}</p>
                <span>故障车辆</span>
              </div>
            </el-card>
            <el-card>
              <div>
                <p class="red-class">{{ todo_event.warning_num }}</p>
                <span>报警信息</span>
              </div>
            </el-card>
          </div>
        </el-card>
        <el-card class="profit-statistic top-mar">
          <div class="title-select">
            <span class="todo-title">总收益趋势</span>
            <el-button-group>
              <el-button
                type="primary"
                @click="profitChartChange('today')"
                size="mini"
                plain
              >
                今天
              </el-button>
              <el-button
                type="primary"
                @click="profitChartChange('sevenDays')"
                size="mini"
                plain
              >
                七天
              </el-button>
              <el-button
                type="primary"
                @click="profitChartChange('fifteenDays')"
                size="mini"
                plain
              >
                十五天
              </el-button>
              <el-button
                type="primary"
                @click="profitChartChange('thirtyDays')"
                size="mini"
                plain
              >
                三十天
              </el-button>
            </el-button-group>
          </div>
          <el-row style="background:#fff;padding:16px 16px 0;">
            <many-line-chart :chart-data="profitChart" height="597px"/>
          </el-row>
        </el-card>
      </div>
      <div style="width:48%;">
        <el-card class="profit-statistic">
          <div class="title-select">
            <span class="todo-title">新用户增长趋势</span>
            <el-button-group>
              <el-button
                type="primary"
                @click="newUsersChartChange('today')"
                size="mini"
                plain
              >
                今天
              </el-button>
              <el-button
                type="primary"
                @click="newUsersChartChange('sevenDays')"
                size="mini"
                plain
              >
                七天
              </el-button>
              <el-button
                type="primary"
                @click="newUsersChartChange('fifteenDays')"
                size="mini"
                plain
              >
                十五天
              </el-button>
              <el-button
                type="primary"
                @click="newUsersChartChange('thirtyDays')"
                size="mini"
                plain
              >
                三十天
              </el-button>
            </el-button-group>
          </div>
          <el-row style="background:#fff;padding:16px 16px 0;">
            <many-line-chart :chart-data="newUsersChart" width="95%"/>
          </el-row>
        </el-card>
        <el-card class="profit-statistic top-mar">
          <div class="title-select">
            <span class="todo-title">新订单趋势</span>
            <el-button-group>
              <el-button
                type="primary"
                @click="changeNewOrderType('nomal')"
                size="mini"
                plain
              >
                普通订单
              </el-button>
              <el-button
                type="primary"
                @click="changeNewOrderType('dayRent')"
                size="mini"
                plain
              >
                日租订单
              </el-button>
            </el-button-group>
            <el-button-group>
              <el-button
                type="primary"
                @click="newOrderChartChange('today')"
                size="mini"
                plain
              >
                今天
              </el-button>
              <el-button
                type="primary"
                @click="newOrderChartChange('sevenDays')"
                size="mini"
                plain
              >
                七天
              </el-button>
              <el-button
                type="primary"
                @click="newOrderChartChange('fifteenDays')"
                size="mini"
                plain
              >
                十五天
              </el-button>
              <el-button
                type="primary"
                @click="newOrderChartChange('thirtyDays')"
                size="mini"
                plain
              >
                三十天
              </el-button>
            </el-button-group>
          </div>
          <el-row style="background:#fff;padding:16px 16px 0;">
            <many-line-chart :chart-data="newOrderChartData"/>
          </el-row>
        </el-card>
      </div>
    </div>
    <div class="buttom-div">
        <!--      <el-card class="ranking-card">-->
        <!--        <div class="title-select">-->
        <!--          <span class="todo-title">骑行排行榜</span>-->
        <!--          <div>-->
        <!--            <el-button-group class="rightr">-->
        <!--              <el-button-->
        <!--                type="primary"-->
        <!--                @click="changeOrderTypeRiddingRanking('nomal')"-->
        <!--                size="mini"-->
        <!--                plain-->
        <!--              >-->
        <!--                普通订单-->
        <!--              </el-button>-->
        <!--              <el-button-->
        <!--                type="primary"-->
        <!--                @click="changeOrderTypeRiddingRanking('dayRent')"-->
        <!--                size="mini"-->
        <!--                plain-->
        <!--              >-->
        <!--                日租订单-->
        <!--              </el-button>-->
        <!--            </el-button-group>-->
        <!--            <el-button-group class="rightr top-bu">-->
        <!--              <el-button-->
        <!--                type="primary"-->
        <!--                @click="riddingRankingChange('today')"-->
        <!--                size="mini"-->
        <!--                plain-->
        <!--              >-->
        <!--                今天-->
        <!--              </el-button>-->
        <!--              <el-button-->
        <!--                type="primary"-->
        <!--                @click="riddingRankingChange('sevenDays')"-->
        <!--                size="mini"-->
        <!--                plain-->
        <!--              >-->
        <!--                七天-->
        <!--              </el-button>-->
        <!--              <el-button-->
        <!--                type="primary"-->
        <!--                @click="riddingRankingChange('oneMonth')"-->
        <!--                size="mini"-->
        <!--                plain-->
        <!--              >-->
        <!--                30天-->
        <!--              </el-button>-->
        <!--              <el-button-->
        <!--                type="primary"-->
        <!--                @click="riddingRankingChange('sixMonth')"-->
        <!--                size="mini"-->
        <!--                plain-->
        <!--              >-->
        <!--                180天-->
        <!--              </el-button>-->
        <!--            </el-button-group>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <el-table :data="tableData" style="width: 100%" :border="false">-->
        <!--          <el-table-column-->
        <!--            prop="ranking"-->
        <!--            label="排名"-->
        <!--            align="center"-->
        <!--            show-overflow-tooltip-->
        <!--            min-width="20%"-->
        <!--          />-->
        <!--          <el-table-column-->
        <!--            prop="phone"-->
        <!--            label="手机号"-->
        <!--            align="center"-->
        <!--            show-overflow-tooltip-->
        <!--            min-width="30%"-->
        <!--          />-->
        <!--          <el-table-column-->
        <!--            prop="total_num"-->
        <!--            label="骑行次数"-->
        <!--            align="center"-->
        <!--            show-overflow-tooltip-->
        <!--            min-width="20%"-->
        <!--          />-->
        <!--        </el-table>-->
        <!--      </el-card>-->
        <el-card class="user-phone">
        <div class="title-select">
          <span class="todo-title">手机统计</span>
          <el-button-group>
            <el-button
              type="primary"
              @click="phoneAnalize('today')"
              size="mini"
              plain
            >
              今天
            </el-button>
            <el-button
              type="primary"
              @click="phoneAnalize('sevenDays')"
              size="mini"
              plain
            >
              七天
            </el-button>
            <el-button
              type="primary"
              @click="phoneAnalize('oneMonth')"
              size="mini"
              plain
            >
              30天
            </el-button>
            <el-button
              type="primary"
              @click="phoneAnalize('sixMonth')"
              size="mini"
              plain
            >
              180天
            </el-button>
          </el-button-group>
        </div>
        <div class="table_and_chart">
          <div class="table-phone">
            <div class="min-title">机型分布</div>
            <el-table :data="userPhoneData" style="width: 100%" :border="false">
              <el-table-column
                prop="model"
                label="机型"
                align="center"
                show-overflow-tooltip
                min-width="50%"
              />
              <el-table-column
                prop="number"
                label="用户数"
                align="center"
                show-overflow-tooltip
                min-width="15%"
              />
              <el-table-column
                label="占比"
                align="center"
                show-overflow-tooltip
                min-width="35%"
              >
                <template slot-scope="scope">
                  <el-progress :percentage="scope.row.percent"/>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="chart-platform">
            <div class="min-title">终端分布</div>
            <pie-chart :chart-data="platformPieChart" height="300px" width="95%"/>
          </div>
        </div>
      </el-card>
      <el-card class="bikes-profit-card">
        <div class="title-select">
          <span class="todo-title">车辆收益排行榜</span>
        </div>
        <el-table :data="BikeProfitRanking" style="width: 100%" :border="false">
          <el-table-column
            type="index"
            label="排名"
            align="center"
            show-overflow-tooltip
            min-width="5%"
          />
          <el-table-column
            prop="bike_no"
            label="车辆编号"
            align="center"
            show-overflow-tooltip
            min-width="30%"
          />
          <el-table-column
            prop="per_money"
            label="平均每日"
            align="center"
            show-overflow-tooltip
            min-width="15%"
          />
          <el-table-column
            prop="total_money"
            label="总收益"
            align="center"
            show-overflow-tooltip
            min-width="15%"
          />
          <el-table-column
            prop="put_days"
            label="总投放时间（天）"
            align="center"
            show-overflow-tooltip
            min-width="15%"
          />
        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  getTopIndex,
  getTodoEvent,
  getProfitChart,
  getNewUsersChart,
  getNewOrderChart,
  getRiddingRankingByDayRentOrder,
  getNewDayRentOrderChart,
  getRiddingRanking,
  getBikeProfitRanking,
  getUserPhoneChart,
} from '@/api/index'
import LineChart from './components/LineChart'
import ManyLineChart from './components/ManyLineChart'
import PieChart from './components/PieChart'
import {indexAreas} from '@/api/area'
import {getMerchant} from '@/api/area'
import env from '../../env'
export default {
  name: 'Index',
  components: {
    LineChart,
    PieChart,
    ManyLineChart,
  },
  data() {
    return {
      isPosSwitch:env.isPosSwitch,
      options: [{
        value: '',
        label: '全部区域',
      }],
      area_id: '',
   select_id:"",
      merchart:[{
        value: '',
        label: '全部商户',
      }],
      merchart_id:'',
      top: {
        new_order: {
          new_num: 0, // 新订单数量
          diff: 2, // 增长情况
          difference: 0, // 实际增长数量
        },
        total_user: {
          total_num: 0,
          diff: 2, // 增长情况
          difference: 0, // 实际增长数量
        },
        total_order: {
          total_num: 0,
          diff: 2, // 增长情况
          difference: 0, // 实际增长数量
        },
        total_profit: {
          total_num: 0,
          diff: 2, // 增长情况
          difference: 0, // 实际增长数量
        },
      },
      todo_event: {
        low_battery_num: 0, // 低电量
        long_time_no_ridding: 0, // 24小时未骑车辆
        long_time_no_return_ridding: 0, // 24小时未还车
        trouble_num: 0, // 故障车辆
        warning_num: 0, // 报警数量
      },
      profitChart: {
        expectedData: {
          data: [],
          date: [],
          legendData: [],
        },
      },
      newUsersChart: {
        expectedData: {
          data: [],
          date: [],
          legendData: [],
        },
      },
      orderType: 'nomal',
      newOrderChartData: {
        expectedData: {
          data: [],
          date: [],
          legendData: [],
        },
      },
      platformPieChart: {
        expectedData: {
          title: '终端比例',
          data: [],
        },
      },
      userPhoneData: [],
      tableData: [],
      BikeProfitRanking: [],
    }
  },
  created() {
    // console.log(222)
    this.getAreas()
    this.initData()
    this.getMerchant()
  },
  methods: {
    seChange() {
      var params = {}
      if (this.area_id !== '') {
        params = { area_id: this.area_id }
      }
      console.log(this.area_id,"00000")
      this.initData(params)
    },
merChange(){
this.options=[]
if(this.merchart_id==""){
  this.initData()
  this.area_id=""
  console.log("这是商户id为空的时候")
}else{
 this.getAreas1()

}

//   console.log(this.select_id,)
//   // var params = {}
//       // if (this.merchart_id !== '') {
//       //   params = { merchart_id: this.merchart_id }
//       // }
//       this.options=[{}]
//       this.getAreas()

//       console.log(this.options,"9999")
//       // let select_id=this.options[0].value

//       // this.area_id=select_id
//           // var params = { area_id: this.area_id}

//           //    this.initData(params)

// console.log(this.select_id,"55555")


},
    async getAreas() {
      const [
        { data: areas },
      ] = await Promise.all([
          indexAreas({merchant_id: this.merchart_id}),
      ])

      areas.map(i => {
        this.options.push({ value: i.id, label: i.name })
      })

    },
     async getAreas1() {
      const [
        { data: areas },
      ] = await Promise.all([
          indexAreas({all: 1, merchant_id: this.merchart_id}),
      ])

      areas.map(i => {
        this.options.push({ value: i.id, label: i.name })
      })
      console.log(this.options,"6776777778")
      this.area_id=this.options[0].value
      console.log(this.area_id,"yuyuuyuui")
      var params={area_id: this.area_id , merchant_id:this.merchart_id}
      this.initData(params)

     },
    async getMerchant(){
      const[
        { data:merchart},
      ]=await Promise.all([
        getMerchant({}),
      ])
      merchart.map(j=>{
         this.merchart.push({value:j.id,label:j.name})
      })
    },
    clearData() {
      this.profitChart.expectedData.data = []
      this.profitChart.expectedData.date = []
      this.profitChart.expectedData.legendData = []

      this.newUsersChart.expectedData.data = []
      this.newUsersChart.expectedData.date = []
      this.newUsersChart.expectedData.legendData = []
      this.newOrderChartData.expectedData.data = []
      this.newOrderChartData.expectedData.date = []
      this.newOrderChartData.expectedData.legendData = []

      this.platformPieChart.expectedData.data = []
    },
    async initData(params = {}) {
      this.clearData()
      // 头部统计
      const [{ data: top }] = await Promise.all([getTopIndex(params)])
      this.top = top

      // 待办事项统计
      const [{ data: todoEvent }] = await Promise.all([getTodoEvent(params)])
      this.todo_event = todoEvent

      // 总收益折线图
      var profitParams = { days: 'thirtyDays' }
      if (params !== {}) {
        profitParams = { days: 'thirtyDays', area_id: params.area_id , merchant_id:this.merchart_id }
      }
      const [{ data: profitChart }] = await Promise.all([
        getProfitChart(profitParams),
      ])
      profitChart.map(i => {
        this.profitChart.expectedData.legendData.push(i.name)
        let arr = []
        let date = []
        i.data.map(e => {
          arr.push(e.value)
          date.push(e.date)
        })
        this.profitChart.expectedData.data.push(arr)
        this.profitChart.expectedData.date = date
      })

      console.log(this.profitChart.expectedData.data)
      // 新增用户折线图

      var newUsersParams = { days: 'thirtyDays' }
      if (params !== {}) {
        newUsersParams = { days: 'thirtyDays', area_id: params.area_id , merchant_id:this.merchart_id}
      }
      const [{ data: newUserChart }] = await Promise.all([
        getNewUsersChart(newUsersParams),
      ])
      newUserChart.map(i => {
        this.newUsersChart.expectedData.legendData.push(i.name)
        let arr = []
        let date = []
        i.data.map(e => {
          arr.push(e.value)
          date.push(e.date)
        })
        this.newUsersChart.expectedData.data.push(arr)
        this.newUsersChart.expectedData.date = date
      })

      // 新订单折线图
      var newOrderParams = { days: 'thirtyDays' }
      if (params !== {}) {
        newOrderParams = { days: 'thirtyDays', area_id: params.area_id, merchant_id:this.merchart_id }
      }
      const [{ data: newOrderChart }] = await Promise.all([
        getNewOrderChart(newOrderParams),
      ])

      newOrderChart.map(i => {
        this.newOrderChartData.expectedData.legendData.push(i.name)
        let arr = []
          let date = []
          i.data.map(e => {
              arr.push(e.value)
              date.push(e.date)
          })
          this.newOrderChartData.expectedData.data.push(arr)
          this.newOrderChartData.expectedData.date = date
      })

        // 排行榜
        var rankingParams = {days: 'oneMonth'}
        if (params !== {}) {
            rankingParams = {days: 'oneMonth', area_id: params.area_id, merchant_id: this.merchart_id}
        }
        // const [{ data: riddingRanking }] = await Promise.all([
        //   getRiddingRanking(rankingParams),
        // ])
        // this.tableData = riddingRanking
        const [{data: BikeProfitRanking}] = await Promise.all([
            getBikeProfitRanking(rankingParams),
        ])
        this.BikeProfitRanking = BikeProfitRanking
        // 手机分析
        var userPhoneParams = {days: 'sixMonth'}
        if (params !== {}) {
            userPhoneParams = {days: 'sixMonth', area_id: params.area_id, merchant_id: this.merchart_id}
        }
        const [{data: userPhone}] = await Promise.all([
            getUserPhoneChart(userPhoneParams),
        ])
        this.userPhoneData = userPhone.userPhone
        this.platformPieChart.expectedData.data = userPhone.platform
    },
    changeNewOrderType(type) {
      this.orderType = type
      this.newOrderChartChange('fifteenDays')
    },
    changeOrderTypeRiddingRanking(type) {
      this.orderType = type
      this.riddingRankingChange('oneMonth')
    },
    async newOrderChartChange(day) {
      this.newOrderChartData.expectedData.data = []
      this.newOrderChartData.expectedData.date = []
      this.newOrderChartData.expectedData.legendData = []
      var newOrderParams = { days: day }
      if (this.area_id !== '') {
        newOrderParams = { days: day, area_id: this.area_id , merchant_id:this.merchart_id}
      }
      if (this.orderType == 'nomal') {
        const [{ data: newOrderChart }] = await Promise.all([
          getNewOrderChart(newOrderParams),
        ])

        newOrderChart.map(i => {
          this.newOrderChartData.expectedData.legendData.push(i.name)
          let arr = []
          let date = []
          i.data.map(e => {
            arr.push(e.value)
            date.push(e.date)
          })
          this.newOrderChartData.expectedData.data.push(arr)
          this.newOrderChartData.expectedData.date = date
        })
      } else if (this.orderType == 'dayRent') {
        const [{ data: newOrderChart }] = await Promise.all([
          getNewDayRentOrderChart(newOrderParams),
        ])

        newOrderChart.map(i => {
          this.newOrderChartData.expectedData.legendData.push(i.name)
          let arr = []
          let date = []
          i.data.map(e => {
            arr.push(e.value)
            date.push(e.date)
          })
          this.newOrderChartData.expectedData.data.push(arr)
          this.newOrderChartData.expectedData.date = date
        })
      }
    },
    async profitChartChange(day) {
      this.profitChart.expectedData.data = []
      this.profitChart.expectedData.date = []
      this.profitChart.expectedData.legendData = []

      var profitParams = { days: day }
      if (this.area_id !== '') {
        profitParams = { days: day, area_id: this.area_id , merchant_id:this.merchart_id}
      }
      const [{ data: profitChart }] = await Promise.all([
        getProfitChart(profitParams),
      ])
      // let ordersCahrtData = []
      profitChart.map(i => {
        this.profitChart.expectedData.legendData.push(i.name)
        let arr = []
        let date = []
        i.data.map(e => {
          arr.push(e.value)
          date.push(e.date)
        })
        this.profitChart.expectedData.data.push(arr)
        this.profitChart.expectedData.date = date
      })
      // profitChart.ordersCahrt.data.map(i => {
      //   ordersCahrtData.push(i.value)
      //   this.profitChart.expectedData.date.push(i.date)
      // })
      // let rechargeOrdersChartData = []
      // profitChart.rechargeOrdersChart.data.map(i => { rechargeOrdersChartData.push(i.value) })
      // let cardRidingOrdersChartData = []
      // profitChart.cardRidingOrdersChart.data.map(i => { cardRidingOrdersChartData.push(i.value) })
      // let depositCardOrdersChartData = []
      // profitChart.depositCardOrdersChart.data.map(i => { depositCardOrdersChartData.push(i.value) })
      // this.profitChart.expectedData.data = {
      //   ordersCahrtData,
      //   rechargeOrdersChartData,
      //   cardRidingOrdersChartData,
      //   depositCardOrdersChartData,
      // }
    },
    async newUsersChartChange(day) {
      this.newUsersChart.expectedData.data = []
      this.newUsersChart.expectedData.date = []
      this.newUsersChart.expectedData.legendData = []
      var profitParams = { days: day }
      if (this.area_id !== '') {
        profitParams = { days: day, area_id: this.area_id , merchant_id:this.merchart_id}
      }
      const [{ data: newUsersCharts }] = await Promise.all([
        getNewUsersChart(profitParams),
      ])
      newUsersCharts.map(i => {
        this.newUsersChart.expectedData.legendData.push(i.name)
        let arr = []
        let date = []
        i.data.map(e => {
          arr.push(e.value)
          date.push(e.date)
        })
        this.newUsersChart.expectedData.data.push(arr)
        this.newUsersChart.expectedData.date = date
      })
    },
    async riddingRankingChange(day) {
      this.tableData = []
      var profitParams = { days: day }
      if (this.area_id !== '') {
        profitParams = { days: day, area_id: this.area_id , merchant_id:this.merchart_id }
      }
      // 排行榜
      if (this.orderType == 'nomal') {
        const [{ data: riddingRanking }] = await Promise.all([
          getRiddingRanking(profitParams),
        ])
        this.tableData = riddingRanking
      } else if (this.orderType == 'dayRent') {
        const [{ data: riddingRanking }] = await Promise.all([
          getRiddingRankingByDayRentOrder(profitParams),
        ])
        this.tableData = riddingRanking
      }

      // console.log(riddingRanking)
    },
    async phoneAnalize(day) {
      this.userPhoneData = []
      // 排行榜
      var profitParams = { days: day }
      if (this.area_id !== '') {
        profitParams = { days: day, area_id: this.area_id , merchant_id:this.merchart_id}
      }
      const [{ data: userPhone }] = await Promise.all([
        getUserPhoneChart(profitParams),
      ])
      this.userPhoneData = userPhone.userPhone
      this.platformPieChart.expectedData.data = userPhone.platform
      // console.log(riddingRanking)
    },

    async bikeProfitRankingChange(day) {
      // 排行榜
      var profitParams = { days: day }
      if (this.area_id !== '') {
        profitParams = { days: day, area_id: this.area_id , merchant_id:this.merchart_id}
      }
      const [{ data: riddingRanking }] = await Promise.all([
        getBikeProfitRanking(profitParams),
      ])
      this.BikeProfitRanking = riddingRanking
      // console.log(riddingRanking)
    },
  },
}
</script>

<style lang="scss" scope>
.title {

    justify-content: space-between;
  margin-left: 10px;
  .wid_l {
    width: 200px;
    margin: 10px 0 0 10px;
  }
   .wid_2 {
    width: 200px;
   margin: 10px 0 0 10px;
  }
}
.top-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 20px;
  .top-card {
    width: 22%;
    height: 108px;
    font-size: 12px;
    color: #666;
    .top-info1 {
      display: flex;
      justify-content: space-between;
      .svg-position {
        padding-left: 10px;
        .svg-class {
          width: 45px;
          height: 45px;
        }
      }
      .content-info {
        text-align: center;
        line-height: 18px;
        color: rgba(50, 50, 50, 0.9);
        font-size: 17px;
        margin-top: 12px;
      }
      .top-item-info1 {
        span {
          display: block;
          text-align: right;
          font-weight: 700;
          font-size: 28px;
        }

        .card-panel-change-text {
          display: inline;
          font-size: 0.8rem;
          margin-right: 5px;
          left: -80px;
          top: 3px;
        }
        .change-num {
          float: right;
          text-align: right;
          margin-top: 15px;
          font-size: 16px;
          display: inline-block;
        }
      }
    }
  }
}
.mid-div {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px;
  .todo-event {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    width: 90%;
    p {
      text-align: center;
      font-size: 1.4rem;
      margin: 5px auto;
    }
    .red-class {
      color: red;
    }
    span {
      color: #6f7180;
      font-size: 0.9rem;
    }
  }
  .todo-title {
    color: #36a3f7;
    font-size: 1.2rem;
    // padding-top: 15px;
  }
  .profit-statistic {
    .title-select {
      display: flex;
      justify-content: space-between;
    }
  }
  .top-mar {
    margin-top: 30px;
  }
}
.buttom-div {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px;
  .ranking-card {
    width: 23%;
    .title-select {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .todo-title {
        color: #36a3f7;
        font-size: 1.2rem;
        // padding-top: 15px;
      }
      .rightr {
        float: right;
      }
      .top-bu {
        margin-top: 10px;
      }
    }
  }
  .user-phone {
      width: 49%;

      .title-select {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;

          .todo-title {
              color: #36a3f7;
              font-size: 1.2rem;
              // padding-top: 15px;
          }
      }
    .table_and_chart {
      display: flex;
      justify-content: space-between;
      .chart-platform {
        width: 35%;
      }
      .min-title {
        text-align: center;
        font-size: 1.1rem;
        margin-bottom: 10px;
      }
      .table-phone {
        width: 60%;
      }
    }
  }
  .bikes-profit-card {
      width: 49%;

      .title-select {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;

          .todo-title {
              color: #36a3f7;
              font-size: 1.2rem;
              // padding-top: 15px;
          }
      }
  }
}
</style>
